import { ActionTypes, LoadBalancerChannelActions } from './load-balancer-channels.actions';
import { LoadBalancerChannelState } from './load-balancer-channels.model';

export const loadBalancerChannelState: LoadBalancerChannelState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getLoadBalancerChannelLoading: false,
  getLoadBalancerChannelLoaded: false,
  loadBalancerChannel: null,
  editLoadBalancerChannelLoading: false,
  editLoadBalancerChannelLoaded: false,
};

export function loadBalancerChannelReducer(
  state: LoadBalancerChannelState = loadBalancerChannelState,
  action: LoadBalancerChannelActions,
): LoadBalancerChannelState {
  switch (action.type) {
    case ActionTypes.LOAD_BALANCER_CHANNELS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.LOAD_BALANCER_CHANNELS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_LOAD_BALANCER_CHANNEL:
      return {
        ...state,
        getLoadBalancerChannelLoading: true,
        getLoadBalancerChannelLoaded: false,
      };
    case ActionTypes.GET_LOAD_BALANCER_CHANNEL_COMPLETED:
      return {
        ...state,
        loadBalancerChannel: action.payload.data,
        getLoadBalancerChannelLoading: false,
        getLoadBalancerChannelLoaded: true,
      };
    case ActionTypes.EDIT_LOAD_BALANCER_CHANNEL:
      return {
        ...state,
        editLoadBalancerChannelLoading: true,
        editLoadBalancerChannelLoaded: false,
      };
    case ActionTypes.EDIT_LOAD_BALANCER_CHANNEL_COMPLETED:
      return {
        ...state,
        editLoadBalancerChannelLoading: false,
        editLoadBalancerChannelLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
